import * as React from 'react'

import { AvailablePaymentMethodsProvider } from '../../../segments/PaymentMethods'
import { useCartContentCtx } from '../../Cart'
import { useFormOrderCtx } from './FormOrderProvider'

type TProps = RequiredChildren

/**
 * Wraps the `AvailablePaymentMethodsProvider` for the form order context.
 * Has to be inside FormOrderProvider.
 * Use the `useAvailablePaymentMethods` to access the payment methods.
 */
export const FormAvailablePaymentMethodsProvider: React.FC<TProps> = ({ children }) => {
  const formOrder = useFormOrderCtx()
  const cartContent = useCartContentCtx()

  // we need to add the totalSum (loaded with the cart content) to the form order
  // totalSum is used to filter out the payment methods that have a maximum amount limit
  // we could load it again with the form order, but we chose to reuse the one already loaded
  const order = React.useMemo(() => {
    if (!formOrder || !cartContent) return null

    return {
      ...formOrder,
      totalSum: cartContent.totalSum,
    }
  }, [cartContent, formOrder])

  return <AvailablePaymentMethodsProvider order={order}>{children}</AvailablePaymentMethodsProvider>
}
